import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import { VALIDATION_MESSAGES } from '../../constants'
import { UserData } from './types'

const fetcher = new Fetcher({})

export const updateUserProfile = async (data: UserData) =>
  fetcher.request<UserData, UserData>({
    url: `${API_DICTIONARY.USERS}${API_DICTIONARY.CURRENT}`,
    method: HTTP_METHODS.PATCH,
    successMessage: `Profile ${VALIDATION_MESSAGES.SM0009} saved.`,
    data
  })
